<template>
  <section id="impact">
    <v-sheet class="stats" color="secondary">
    <div class="py-12"></div>
  
          <div class="display-2 font-weight-bold mb-3 text-center">{{ $t('menuCharity') }}</div>
    <div class="py-6"></div>

    <v-container>
      <v-row>
        <v-col v-for="({ src, text, title, author, to }, i) in articles" :key="i" cols="12" md="4">
          <v-card class="mx-auto" max-width="400" height="550">
            <v-img
              class="white--text align-end"
              :src="src"
              height= 300px
              contain
            >  
            </v-img>
            <v-card-title v-text="$t(title)"></v-card-title>
            <v-card-subtitle class="pb-0" v-html="author"></v-card-subtitle>

            <v-card-text class="text--primary" v-html="$t(text)">
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="orange" text :to=to  style="position: absolute; bottom: 10px; right: 10px;">{{ $t('charityMore') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <div class="py-12"></div>
    </v-sheet>
  </section>
</template>

<script>
export default {
  name: "News",
  data: () => {
    return {
      articles: [
        {
          src: require("../assets/StreetUnverCity16.jpg"),
          title: 'charityTitle1',
          text: 'charitySubTitle1',
          to: "/projects/1"
        },
        {
          src: require("../assets/startupmate.png"),
          title: 'charityTitle2',
          text: 'charitySubTitle2',
          to: "/projects/2"
        },
        {
          src: require("../assets/lets_celebrate.png"),
          title: 'charityTitle3',
          text: 'charitySubTitle3',
          to: "/projects/3"
        }
      ]
    };
  }
};
</script>
